import { zodResolver } from "@hookform/resolvers/zod/dist/zod";
import { ReferralOfExaminersRequest } from "services/examinersService/Model/ExaminerTypes";
import { z } from "zod";
import {ReferralOfRefereesRequest} from "../../../../../../../../../services/RefereeService/Model/RefereeTypes";

export const getReferRefereeSchema = (t: any) => {
  const schema = z.object({
    deadLine: z.date({
      message: t("Common:invalidValue"),
    }),
    refereeIds: z.array(z.number().min(1, t("Common:invalidValue"))).min(1, t("pleaseSelectAtLeastOneReferee")),
    notes: z.string().optional(),
  }) as z.ZodType<ReferralOfRefereesRequest>;

  return zodResolver(schema);
};
